var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomV2PottyV9(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.1644 16.6694V7.12073",
    stroke: "#7A7670",
    style: (_ref2 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.836 7.12073V16.6694",
    stroke: "#7A7670",
    style: (_ref3 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49707 8.60284L8.89246 2.91805C9.5242 2.3565 10.4762 2.3565 11.1079 2.91805L17.5033 8.60284",
    stroke: "#7A7670",
    style: (_ref4 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91382 16.6694H17.0864",
    stroke: "#7A7670",
    style: (_ref5 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref5, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref5, "strokeOpacity", 1), _ref5),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99982 10.4168V10.4168C11.3811 10.4168 12.5009 11.5366 12.5009 12.9179V12.9179C12.5009 13.139 12.413 13.351 12.2567 13.5074C12.1003 13.6637 11.8883 13.7516 11.6672 13.7516H8.33246C7.87203 13.7516 7.49878 13.3783 7.49878 12.9179V12.9179C7.49878 11.5366 8.61853 10.4168 9.99982 10.4168V10.4168Z",
    stroke: "#7A7670",
    style: (_ref6 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref6, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref6, "strokeOpacity", 1), _ref6),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2085 7.91607C10.2084 8.03111 10.115 8.12427 10 8.12422C9.88497 8.12417 9.79172 8.03093 9.79167 7.91589C9.79162 7.80085 9.88479 7.70753 9.99983 7.70738C10.0552 7.70731 10.1083 7.72927 10.1475 7.76842C10.1866 7.80757 10.2086 7.86069 10.2085 7.91606",
    stroke: "#7A7670",
    style: (_ref7 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref7, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref7, "strokeOpacity", 1), _ref7),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7097 8.74974C12.7096 8.86478 12.6163 8.95795 12.5012 8.9579C12.3862 8.95786 12.2929 8.86461 12.2929 8.74957C12.2928 8.63453 12.386 8.54121 12.501 8.54106C12.5564 8.54099 12.6095 8.56295 12.6487 8.6021C12.6878 8.64125 12.7098 8.69437 12.7097 8.74974",
    stroke: "#7A7670",
    style: (_ref8 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref8, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref8, "strokeOpacity", 1), _ref8),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70754 8.74975C7.70739 8.86479 7.61406 8.95795 7.49903 8.9579C7.38399 8.95785 7.29074 8.86461 7.2907 8.74957C7.29065 8.63453 7.38381 8.54121 7.49885 8.54106C7.55422 8.54099 7.60734 8.56295 7.64649 8.6021C7.68564 8.64125 7.7076 8.69437 7.70754 8.74974",
    stroke: "#7A7670",
    style: (_ref9 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref9, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref9, "strokeOpacity", 1), _ref9),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomV2PottyV9);
export default __webpack_public_path__ + "static/media/customV2PottyV9.a09e4eb6943616b910365a132dcb10f7.svg";
export { ForwardRef as ReactComponent };